import { render } from "./SocialLinks.vue?vue&type=template&id=f9af78ee&scoped=true"
const script = {}

import "./SocialLinks.vue?vue&type=style&index=0&id=f9af78ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9af78ee"]])

export default __exports__